import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/finance/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import FeaturesList from "../components/finance/FeaturesList";
import Cta from "../components/finance/Cta";
import Testimonials from "../components/finance/Testimonials";

const Finance = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <FeaturesList />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default Finance;

